import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';
import {
  GetSupportRequestsInputDto,
  GetSupportRequestsOutputDto,
} from '../../../models/support/dto/get-support-requests.dto';

export const GET_SUPPORT_REQUESTS_QUERY_KEY = 'support-requests';

export const useGetSupportRequests = (params: GetSupportRequestsInputDto) => {
  const client = useApiClient();

  const page = params.page ?? 0;
  const limit = params.limit ?? 10;
  const organizationId = params.organizationId;

  return useQuery({
    queryKey: [GET_SUPPORT_REQUESTS_QUERY_KEY, page, limit, organizationId],
    enabled: !!organizationId,
    queryFn: async () => {
      const queryParams = new URLSearchParams();
      queryParams.append('page', page.toString());
      queryParams.append('limit', limit.toString());
      if (organizationId) {
        queryParams.append('organizationId', organizationId);
      }

      const endpoint = `support/requests?${queryParams.toString()}`;

      return client.fetchApi<GetSupportRequestsOutputDto, {}>({
        endpoint,
        method: 'GET',
      });
    },
    staleTime: 30 * 1000, // 30 seconds
    cacheTime: 5 * 60 * 1000, // Keep in cache for 5 minutes
    keepPreviousData: true, // Keep showing previous data while loading new page
  });
};
